<template>
    <div class="link-info">
        <div class="info-header">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">链路信息</span>
                <span class="info-header-icon" @click="showLog">log</span>
            </div>
        </div>
        <div class="link-process">
            <div class="link-process-item" v-for="(item, index) in linkInfo" :key="index" :style="'width:'+(100/(linkInfo.length))+'%'">
                <div class="link-process-content">
                    <div class="link-process-icon" :style="'background-image:url('+(item.isShow=== 1 ? active : notActive)+')'"></div>
                    <div class="link-process-name">{{item.dispatchStatusName}}</div>
                    <div class="link-process-time" @dblclick="copyCreateTime($event)">{{ item.createTime }}</div>
                </div>
                <div class="link-process-point">
                    <span class="arrow" :class="linkInfo[index] && linkInfo[index].isShow === 1 ? 'active' : 'notActive'"></span>
                    <span class="bigPoint" :class="linkInfo[index+1] && linkInfo[index+1].isShow === 1 ? 'point-active ' : 'point-not-active'"></span>
                    <span class="arrow" :class="linkInfo[index+1] && linkInfo[index+1].isShow === 1 ? 'active' : 'notActive'"></span>
                    <i class="el-icon-arrow-right" :class="linkInfo[index+1] && linkInfo[index+1].isShow === 1 ? 'right-active' : 'right-not-active'"></i>
                </div>
            </div>
        </div>
        <operation-node-log
            ref="operationNodeLog"
            v-if="isShowOperationNodeLog"
            :isShowOperationNodeLog.sync="isShowOperationNodeLog"
            :dictData="dictData"
            :componentsData="componentsData"
        ></operation-node-log>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
import bigDataLog from '@/utils/bigDataLog';
import OperationNodeLog from '../../components/operationNodeLog/Index.vue';
export default {
    name: 'LinkInformation',
    components: { OperationNodeLog },
    props: {
        linkInfo: {
            type: Array,
            default () {
                return [];
            }
        },
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            active: require('@/assets/carActive.png'),
            notActive: require('@/assets/carNotActive.png'),
            isShowOperationNodeLog: false
        };
    },
    methods: {
        /**
         * @description 复制节点时间
         */
        copyCreateTime (e) {
            const value = (e.target.innerHTML).trim();
            copyToClip(value);
        },
        showLog () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-dispatch-log');
            this.isShowOperationNodeLog = true;
        }
    }
};
</script>

<style lang="less">
@import '../dispatchInfoDetail.less';
.link-info {
    background-color: #fff;
    margin-bottom: 14px;
}
.link-process {
    height: 120px;
    display: flex;
    justify-content: center;
    // align-items: center;
    .link-process-item {
        position: relative;
        .link-process-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            .link-process-icon {
                width: 36px;
                height: 36px;
                line-height: 36px;
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
                display: flex;
                margin-top: 20px;
            }
            .link-process-name {
                margin: 8px 0;
            }
            .link-process-time {
                font-size: 14px;
            }
        }
        .link-process-point {
            display: flex;
            align-items: center;
            position: absolute;
            right: -46px;
            top: 40px;

            .arrow {
                height: 1px;
                width: 30px;
            }
            .active {
                border-bottom: dashed #00bcbf;
            }
            .notActive {
                border-bottom: dashed #999;
            }
            .bigPoint {
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                margin: 0px 4px;
            }
            .point-active {
                background-color: #00bcbf;
            }
            .point-not-active {
                background-color: #999;
            }
            .el-icon-arrow-right {
                font-weight: bold;
            }
            .right-active {
                color: #00bcbf;
            }
            .right-not-active {
                color: #999;
            }
        }
        &:last-child .link-process-point {
                display: none;
            }
    }
}

</style>
